import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

export class LastManStandingPobjednici extends React.Component {

    constructor(props) {
        super(props);
        this.state = { prikaziSveRatnike: false };

        this.renderPobjednike = this.renderPobjednike.bind(this);
        this.renderPobjednikRow = this.renderPobjednikRow.bind(this);
        this.renderRatniciUBorbi = this.renderRatniciUBorbi.bind(this);
        this.renderRatnikRow = this.renderRatnikRow.bind(this);
        this.prikaziSveRatnike = this.prikaziSveRatnike.bind(this);
    }

    renderPobjednike() {
        return <table className="table-1 v2 v3">
            <thead>
                <tr>
                    <th className="text-left text text-6">Mjesec</th>
                    <th className="text-left text text-6">Preživjeli</th>
                    <th className="text-right text text-6">Osvojeno</th>
                </tr>
            </thead>
            <tbody>
                {(!this.props || !this.props.pobjednici) && <tr className="horizontal-lines"><td colSpan="5"><span className="text text-1">Trenutno nema rezultata...</span></td></tr>}

                {this.props && this.props.pobjednici && !this.props.pobjednici.length && <tr className="horizontal-lines"><td colSpan="5"><span className="text text-1">Trenutno nema rezultata...</span></td></tr>}
                {this.props && this.props.pobjednici && this.props.pobjednici.map(this.renderPobjednikRow)}
            </tbody>
        </table>
    }
    renderPobjednikRow(pobjednik, i) {

        if (i > 20)
            return null;

        return (
            <tr key={i} className="horizontal-lines">
                <td>
                    <span className="text text-1">{pobjednik.mjesec}</span>
                </td>
                <td className="text text-1">
                    <span className="text-bold">{pobjednik.prezivjeli}</span> {pobjednik.prezivjeli == 1 ? 'preživjeli igrač' : 'preživjela igrača'}
                </td>
                <td>
                    <div className="dobitak-iznos gold pull-right smaller" >
                        <div className="bg-left "></div>
                        <div className="iznos text-ellipsis">{casino.utils.numberWithCurrencyFromated(pobjednik.nagrada,'EUR')}</div>
                        <div className="bg-right"></div>
                    </div>
                </td>
            </tr>
        );
    }

    renderRatniciUBorbi() {
        /*** Za logiranog igraca ***/
        var that = this;
        let logiraniIgracNadimak = this.props && this.props.ratniciUBorbi && this.props.user ? this.props.ratniciUBorbi.filter(function (nadimak) { return nadimak == that.props.user.nadimak; })[0] : null;
        let logiraniIgracJeKvalificiran = this.props.user && logiraniIgracNadimak == this.props.user.nadimak ? true : false;
        /**************************/

        return (
            <div className="ratnici-u-borbi-container">
                {(!this.props || !this.props.ratniciUBorbi) && <div className="padding-sides-medium-2 padding-bottom">Dohvaćanje ratnika...</div>}
                {this.props && this.props.ratniciUBorbi && !this.props.ratniciUBorbi.length && <div className="padding-sides-medium-2 padding-bottom">Trenutno nema ratnika...</div>}
                {logiraniIgracJeKvalificiran && <div className="logged-user"><span className="icon"></span><span className="text text-ellipsis">Ja</span><span className="text">Još uvijek sudjeluješ u ratu</span></div>}
                <div className="ratnici">
                    {this.props && this.props.ratniciUBorbi && this.props.ratniciUBorbi.map(this.renderRatnikRow)}
                </div>
                {
                    this.props && this.props.ratniciUBorbi && this.props.ratniciUBorbi.length > 20 && !this.state.prikaziSveRatnike
                    && <div className="text-center"><div onClick={() => this.prikaziSveRatnike()} className="btn medium fill gray blue margin-top margin-bottom no-text-transform" target="_blank" ><span>Prikaži sve ({this.props.ratniciUBorbi.length - 20})</span></div></div>
                }
            </div>
        )
    }

    renderRatnikRow(ratnik, i) {
        return <div key={"ratnik-" + i} className={"ratnik " + (i > 19 && !this.state.prikaziSveRatnike ? 'hidden' : '')}><span className="icon"></span><span className="text text-ellipsis">{ratnik}</span></div>

    }

    prikaziSveRatnike() {
        this.setState({
            prikaziSveRatnike: true
        });
    }

    render() {
        return <div>
            {this.props && this.props.ratniciUBorbi && this.props.ratniciUBorbi.length > 0 &&
                <div>
                    <div className="padding-sides-medium-2 border-top-small white-background">
                        <h2 className='v4 margin-bottom-small margin-top'>Ratnici u borbi</h2>
                    </div>
                    {this.renderRatniciUBorbi()}
                </div>
            }
            <div className="padding-sides-medium-2 border-top-small white-background">
                <h2 className='v4 margin-bottom-small margin-top'>Dobitnici ratova</h2>
            </div>
            {this.renderPobjednike()}
        </div>

    }
};
